module.exports = __webpack_public_path__ + "img/cinta3.3a520d59.jpg";